/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImportDataErrorMessage,
    ImportDataErrorMessageFromJSON,
    ImportDataErrorMessageFromJSONTyped,
    ImportDataErrorMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ImportDataValidatonError
 */
export interface ImportDataValidatonError {
    /**
     * 
     * @type {string}
     * @memberof ImportDataValidatonError
     */
    dataRow?: string | null;
    /**
     * 
     * @type {Array<ImportDataErrorMessage>}
     * @memberof ImportDataValidatonError
     */
    messages?: Array<ImportDataErrorMessage> | null;
}

export function ImportDataValidatonErrorFromJSON(json: any): ImportDataValidatonError {
    return ImportDataValidatonErrorFromJSONTyped(json, false);
}

export function ImportDataValidatonErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportDataValidatonError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataRow': !exists(json, 'dataRow') ? undefined : json['dataRow'],
        'messages': !exists(json, 'messages') ? undefined : (json['messages'] === null ? null : (json['messages'] as Array<any>).map(ImportDataErrorMessageFromJSON)),
    };
}

export function ImportDataValidatonErrorToJSON(value?: ImportDataValidatonError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dataRow': value.dataRow,
        'messages': value.messages === undefined ? undefined : (value.messages === null ? null : (value.messages as Array<any>).map(ImportDataErrorMessageToJSON)),
    };
}


